<template>
  <div
    class="mb-3"
    :class="{ 'd-none': item.displayOn && !display_none_check }"
    @click="parentMouseClickHandler"
  >
    <div class="p-4 card" style="height: calc(100vh - 280px); color: #000">
      <div class="flex justify-content-between mb-1 info-container">
        <div class="flex">
          <div class="indicator patient mr-4">
            <span class="color-box"></span>
            Patient
          </div>
          <div class="indicator practice">
            <span class="color-box"></span>
            Practice
          </div>
        </div>
        <div>{{ selectedItem.status }}</div>
        <div class="inline-flex">
          <img
            v-if="showComments"
            src="@/assets/images/pv-chat-green.svg"
            alt="logo"
            class="mr-3 cursor-pointer cmd-icon"
            @click="toggleComments()"
          />
          <img
            v-else
            src="@/assets/images/pv-chat.svg"
            alt="logo"
            class="mr-3 cursor-pointer cmd-icon"
            @click="toggleComments()"
          />
          <input
            v-if="showSearch"
            v-model="searchText"
            type="text"
            class="form-control mT5 p0 searchText"
            placeholder="Search"
            @blur="toggerSearchInput"
            autofocus
          />
          <img
            v-else
            src="@/assets/images/pv-search.svg"
            class="pointer"
            @click="toggerSearchInput()"
            alt="logo"
          />
        </div>
      </div>
      <hr />
      <!-- <highlightable @share="onShare" @highlight="onHighlight">
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eveniet at
                    debitis deserunt, optio rem eaque obcaecati non possimus nisi assumenda
                    architecto exercitationem dolore quo praesentium, deleniti reiciendis
                    sed ab nihil!
                </p>
            </highlightable> -->
      <div id="chat-container" @scroll="handleScroll" class="chat-window mt-1">
        <div
          v-if="showButton"
          :style="{ top: buttonPosition.top, left: buttonPosition.left }"
          class="strick-button"
        >
          <img
            src="@/assets/images/strick-icon.svg"
            alt="logo"
            class="mr-3 cursor-pointer"
            @click="stickthemessage"
          />
        </div>
        <div
          v-if="showRevertButton"
          :style="{ top: buttonPosition.top, left: buttonPosition.left }"
          class="strick-button"
        >
          <img
            src="@/assets/images/revert-stick.svg"
            alt="logo"
            class="mr-3 cursor-pointer"
            @click="revertStickthemessage"
          />
        </div>
        <div v-for="message in filteredMessages" :key="message.id">
          <div
            :class="`flex ${
              message.sender == 'patient' ? '' : 'justify-content-end'
            }`"
          >
            <img
              v-if="message.sender == 'practice' && showComments"
              src="@/assets/images/pv-add.svg"
              alt="logo"
              class="mr-3 cursor-pointer"
              @click="addComment(message.id)"
            />
            <p
              :id="'message-' + message.id"
              @mouseup="
                (e) => {
                  handleMouseUp(e, message, message);
                }
              "
              :class="`message ${message.sender}`"
              v-html="applyBlackoutSpan(message, message.text)"
            ></p>

            <img
              v-if="message.sender == 'patient' && showComments"
              src="@/assets/images/pv-add.svg"
              alt="logo"
              class="ml-3 cursor-pointer"
              @click="addComment(message.id)"
            />
          </div>

          <div
            v-for="comment in getFilteredCommends(message.comments)"
            :key="comment.id"
          >
            <div
              v-if="showComments"
              :class="`flex ${
                message.sender == 'patient' ? '' : 'justify-content-end'
              }`"
            >
              <img
                v-if="message.sender == 'practice'"
                src="@/assets/images/pv-remove.svg"
                alt="logo"
                class="mr-3 cursor-pointer"
                @click="removeComment(message.id, comment.id)"
              />
              <!-- <p
                :class="`message ${message.sender} comment`"
                contenteditable
                @blur="handleComment(message, comment.text)"
              >
                {{ comment.text }}
              </p> -->
              <textarea
                :class="`message ${message.sender} comment`"
                type="text"
                v-model="comment.text"
                placeholder="Add comment"
                @blur="handleComment(message, comment.text)"
                @input="adjustTextareaHeight"
              />
              <img
                v-if="message.sender == 'patient'"
                src="@/assets/images/pv-remove.svg"
                alt="logo"
                class="ml-3 cursor-pointer"
                @click="removeComment(message.id, comment.id)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { patch } from "../../../components/service/page.service";
// import Highlightable from './Highlightable'

export default {
  // components: { Highlightable },
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
    topbarControls: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      searchText: "",
      showButton: false,
      showSearch: false,
      showRevertButton: false,
      selectedComments: null,
      selectedMessage: null,
      buttonPosition: { top: "0px", left: "0px" },
      value: this.item_value,
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
      chatData: [
        {
          id: 1,
          sender: "patient",
          text: "Hello, I have a quick question regarding my appointment.",
          comments: [
            {
              id: 11,
              text: "Lorem Ipsum patient",
            },
          ],
        },
        {
          id: 2,
          sender: "practice",
          text: "Good Afternoon, I am a patient navigator. I would be glad to assist you. What is your query?",
          comments: [
            {
              id: 21,
              text: "Lorem Ipsum practice",
            },
          ],
        },
        {
          id: 3,
          sender: "patient",
          text: "Can I eat before the blood test as the appointment is at 12?",
          comments: [],
        },
        {
          id: 4,
          sender: "practice",
          text: "We ask patients not to eat anything for ten hours before the blood test. You can drink clear fluids and water.",
          comments: [],
        },
      ],
      showComments: false,
    };
  },
  computed: {
    filteredMessages() {
      if (
        (this.value && this.value.length && this.searchText !== null) ||
        this.searchText !== ""
      ) {
        return this.value.filter((item) => {
          return item.text
            .toLowerCase()
            .includes(this.searchText.toLowerCase());
        });
      }
      return this.value;
    },
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
  },
  watch: {
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
    selectedItem: {
      handler(val) {
        this.d_check = val ? val[this.item.displayOn] : false;
        this.handlePatientVoicedata();
      },
      deep: true,
    },
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
      },
      deep: true,
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
  },
  methods: {
    async handlePatientVoicedata() {
      let { chat, presignedUrl, title } = this.selectedItem;
      if (chat && !chat.length && presignedUrl) {
        let { transcription, status } = await this.extractTextFromUploadedFile(
          title
        );
        if (transcription) {
          let chat = this.convertTranscription(transcription);
          if (chat && chat.length) {
            await this.patchUpdateChat(chat, status);
            this.topp
          }
        }
      }
    },
    async patchUpdateChat(chat, status) {
      this.selectedItem.chat = chat;
      this.selectedItem.status = status;
      await patch(this.selectedItem.id, this.selectedItem);
      this.topbarControls.prevSelectedItem = JSON.stringify(this.selectedItem)

    },
    convertTranscription(transcription) {
      let data = [];
      if (transcription && transcription.length) {
        transcription.forEach((rt) => {
          let d = {
            comments: [],
            id: uuidv4(),
            strickMessage: [],
            text: rt.content,
          };
          if (rt.speaker_label === "spk_0") {
            d.sender = "practice";
          } else {
            d.sender = "patient";
          }
          data.push(d);
        });
      }
      return data;
    },
    async extractTextFromUploadedFile(fileName) {
      let data = JSON.stringify({
        file_name: `${fileName}`,
      });
      try {
        const response = await axios.post(
          "https://ngcci3rslg.execute-api.eu-west-1.amazonaws.com/Prod/v1/extract-text",
          data,
          {
            headers: {
              "x-api-key": "PLPWufjyeH7b5tIjOuh988fxid2I8tj71i0P4o64",
              "Content-Type": "application/json",
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error extracting text:", error);
        throw new Error("Failed to extract text");
      }
    },
    getFilteredCommends(value) {
      if ((value && this.searchText !== null) || this.searchText !== "") {
        return value.filter((item) => {
          return item.text
            .toLowerCase()
            .includes(this.searchText.toLowerCase());
        });
      }
      return value;
    },
    toggerSearchInput() {
      this.showSearch = !this.showSearch;
    },
    adjustTextareaHeight(event) {
      const textarea = event.target;
      textarea.style.height = "auto"; // Reset height to recalculate
      textarea.style.height = textarea.scrollHeight + "px"; // Set to scroll height
    },
    revertStickthemessage(event) {
      event.preventDefault(); // Prevent the default action associated with the event

      // Destructure selectedText and comment from this.selectedComments
      let { selectedText, comment } = this.selectedComments;

      // Check if the comment has an id
      if (comment.id) {
        // Iterate over each item in this.value
        this.value.forEach((item) => {
          // Check if the current item matches the comment by id
          console.log("item.id", item.id, comment.id);
          if (
            item.id === comment.id &&
            item.strickMessage &&
            item.strickMessage.length
          ) {
            // Find the index of the selectedText in the item's stickthemessage array
            const index = item.strickMessage.indexOf(selectedText);
            console.log("index", index);

            // If the selectedText is found in the array
            if (index !== -1) {
              // Remove the selectedText from the array using splice
              item.strickMessage.splice(index, 1);
            }
          }
        });
      }
      this.handleScroll();
    },

    parentMouseClickHandler() {
      const selection = window.getSelection();
      if (selection.toString().length === 0) {
        this.handleScroll();
      }
    },
    handleScroll() {
      this.showButton = false;
      this.selectedComments = null;
      this.showRevertButton = false;
    },
    handleComment() {
      // handle comment funtion
    },
    stringifyClone(originalObject) {
      return JSON.parse(JSON.stringify(originalObject));
    },
    stickthemessage(event) {
      event.preventDefault();

      if (this.selectedComments !== null) {
        let { comment, selectedText } = this.selectedComments;
        let { id } = comment;
        selectedText = selectedText.replace(/\r?\n|\r/g, "");

        this.value.forEach((item) => {
          if (item.id === id) {
            // let escapedSelectedText = selectedText.replace(
            //   /[.?*+^$[\]\\(){}|-]/g,
            //   "\\$&"
            // );
            if (!item.strickMessage) {
              item.strickMessage = [];
            }
            item.strickMessage.push(selectedText);
            console.log("------>", selectedText, item.strickMessage);
            this.handleScroll();
          }
        });
      }
    },
    handleMouseUp(event, comment, message) {
      const selection = window.getSelection();
      if (selection.toString().length > 0) {
        this.selectedComments = {
          comment: comment,
          selectedText: selection.toString(),
        };
        const range = selection.getRangeAt(0);
        const rect = range.getBoundingClientRect();
        let width = rect.width;
        // let position = rect.left - (width/2)
        let halfwidth = width / 3;
        if (halfwidth > 50) {
          halfwidth = width / 2;
        }
        this.buttonPosition = {
          top: `${rect.top + window.scrollY - 30}px`, // Adjust as needed
          left: `${rect.left + window.scrollX + halfwidth - 5}px`,
        };
        let patternToExclude = /---\.---/;

        // Search for any character except the pattern
        let result = selection
          .toString()
          .search(
            new RegExp(
              `[^${patternToExclude.source.replace(
                /[-[\]{}()*+?.,\\^$|#\s]/g,
                "\\$&"
              )}]`
            )
          );

        if (result !== -1) {
          // Check if 'strickMessage' exists and has elements, and if the current selection is included in 'strickMessage'
          if (
            message.strickMessage &&
            message.strickMessage.includes(selection.toString())
          ) {
            this.showButton = false;
            this.showRevertButton = true;
          } else {
            this.showButton = true;
            this.showRevertButton = false;
          }
        } else {
          // Handle the case where no matching character was found
          this.selectedMessage = message;
          this.showButton = false;
          this.showRevertButton = false;
          console.log("No character found.");
        }
      } else {
        this.handleScroll();
      }
    },
    onShare(text) {
      console.log("share:", text);
    },
    onHighlight(text) {
      console.log("highlight:", text);
    },
    toggleComments() {
      this.showComments = !this.showComments;
      this.$nextTick(() => {
        const textareas = this.$el.querySelectorAll("textarea");
        textareas.forEach((textarea) => {
          textarea.style.height = "auto";
          textarea.style.height = textarea.scrollHeight + "px";
        });
      });
    },
    addComment(mid) {
      // const messages = [...this.value]
      this.value
        .find((x) => x.id === mid)
        .comments.push({
          id: uuidv4(),
          text: "",
        });
    },
    removeComment(mid, cid) {
      const messages = [...this.value];
      let comments = messages.find((x) => x.id === mid).comments;
      comments = comments.filter((x) => x.id !== cid);
      this.value.find((x) => x.id === mid).comments = comments;
    },
    replaceSubstringWithStyledSpan(message, inputSentence) {
      // console.log('inputSentence', inputSentence, message)
      if (!inputSentence) return "";
      const targetSubstring = "-";
      const styles = "color: black; background: black;";

      // Calculate the length of the replacement string based on the targetSubstring
      const replacementLength = targetSubstring.length;
      const replacementString = "-".repeat(replacementLength);

      const replacedSentence = inputSentence.replace(
        new RegExp(targetSubstring, "gi"),
        () => {
          return `<span style="${styles}">${replacementString}</span>`;
        }
      );

      return replacedSentence;
    },
    applyBlackoutSpan(message, inputSentence) {
      if (!inputSentence) return "";
      const styles = "color: black; background: black;";
      if (message.strickMessage && message.strickMessage.length) {
        let strickMessage = message.strickMessage;
        strickMessage.forEach((message) => {
          const escapedMessage = message.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          inputSentence = inputSentence.replace(
            new RegExp(escapedMessage, "gi"),
            (match) => {
              return `<span style="${styles}">${match}</span>`; // Keep the original matched text
            }
          );
        });
      }

      return this.replaceSubstringWithStyledSpan(message, inputSentence);
    },
  },
  mounted() {
    this.item.display = false;
  },
};
</script>
<style scoped>
.cmd-icon {
  width: 20px;
  height: 18px;
  margin-top: 9px;
}
.info-container {
  min-height: 34px;
}
.searchText {
  height: calc(1.5em + 0.94rem + 2px);
}
.inline-flex {
  display: inline-flex;
}
.pointer {
  cursor: pointer;
}
.message.comment {
  min-height: 50px; /* Adjust as needed */
  overflow-y: hidden; /* Prevent scrollbar */
  resize: none;
}
.strick-button {
  position: fixed;
}
.chat-container {
  max-width: 600px;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

.search-bar input {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
}

.chat-window {
  /* max-height: 400px; */
  overflow-y: auto;
}

.message {
  padding: 10px;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  width: 70%;
  border-radius: 5px;
}

.message.patient {
  background-color: #f6f8fc;
  text-align: left;
  margin-left: 0;
  /* margin-right: auto; */
  border-radius: 10px;
  border-top-left-radius: 0px;
}

.message.practice {
  background-color: #e7f3ff;
  /* text-align: right; */
  /* margin-left: auto; */
  margin-right: 0;
  border-radius: 10px;
  border-top-right-radius: 0px;
}
.message.patient.comment {
  background-color: #e1ffea;
  text-align: left;
  margin-left: 0;
  /* margin-right: auto; */
  outline: none;
  border: none;
  border-radius: 10px;
  border-top-left-radius: 10px;
}
.message.practice.comment {
  background-color: #e1ffea;
  /* text-align: right; */
  /* margin-left: auto; */
  margin-right: 0;
  outline: none;
  border: none;
  border-top-right-radius: 10px;
}
.chat-header {
  display: flex;
  justify-content: justify-content-between;
  margin-bottom: 20px;
}

.indicator {
  display: flex;
  align-items: center;
}

.color-box {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.indicator.patient .color-box {
  background-color: #f6f8fc;
}

.indicator.practice .color-box {
  background-color: #e7f3ff;
}
</style>
